import { DefaultOptionType } from '@ui-components/neo.tax';

export const defaultMonthOptions: DefaultOptionType<number>[] = [
  { label: 'January', value: 0 },
  { label: 'February', value: 1 },
  { label: 'March', value: 2 },
  { label: 'April', value: 3 },
  { label: 'May', value: 4 },
  { label: 'June', value: 5 },
  { label: 'July', value: 6 },
  { label: 'August', value: 7 },
  { label: 'September', value: 8 },
  { label: 'October', value: 9 },
  { label: 'November', value: 10 },
  { label: 'December', value: 11 },
];

export const startOfMonthOptions: DefaultOptionType<number>[] = [
  { label: 'January 1st', value: 0 },
  { label: 'February 1st', value: 1 },
  { label: 'March 1st', value: 2 },
  { label: 'April 1st', value: 3 },
  { label: 'May 1st', value: 4 },
  { label: 'June 1st', value: 5 },
  { label: 'July 1st', value: 6 },
  { label: 'August 1st', value: 7 },
  { label: 'September 1st', value: 8 },
  { label: 'October 1st', value: 9 },
  { label: 'November 1st', value: 10 },
  { label: 'December 1st', value: 11 },
];

export const endOfMonthOptions: DefaultOptionType<number>[] = [
  { label: 'January 31st', value: 0 },
  { label: 'February 28th', value: 1 },
  { label: 'March 31st', value: 2 },
  { label: 'April 30th', value: 3 },
  { label: 'May 31st', value: 4 },
  { label: 'June 30th', value: 5 },
  { label: 'July 31st', value: 6 },
  { label: 'August 31st', value: 7 },
  { label: 'September 30th', value: 8 },
  { label: 'October 31st', value: 9 },
  { label: 'November 30th', value: 10 },
  { label: 'December 31st', value: 11 },
];

export const endOfMonthLeapYearOptions: DefaultOptionType<number>[] = [
  { label: 'January 31st', value: 0 },
  { label: 'February 29th', value: 1 },
  { label: 'March 31st', value: 2 },
  { label: 'April 30th', value: 3 },
  { label: 'May 31st', value: 4 },
  { label: 'June 30th', value: 5 },
  { label: 'July 31st', value: 6 },
  { label: 'August 31st', value: 7 },
  { label: 'September 30th', value: 8 },
  { label: 'October 31st', value: 9 },
  { label: 'November 30th', value: 10 },
  { label: 'December 31st', value: 11 },
];

export const defaultYearOptions: DefaultOptionType<number>[] = Array.from(
  { length: 10 },
  (_, i) => new Date().getUTCFullYear() - i,
).map((year) => ({
  label: year.toString(),
  value: year,
}));
